// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l7Lb","type":"styles_type__14s2h","choices":"styles_choices__3P87C"};